import React from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { useParams } from "react-router";
import { css } from "@emotion/react";
import backgroundImage from "assets/images/Faith-2000x1340-c-center.jpg";
import { LoginContainer, SetPasswordForm } from "components/Login";
import { useQueryData } from "hooks";
import { GET_PUBLIC_USER } from "graphql/queries";
import { Spinner } from "components/Loader";
import { colors, fontSize } from "style";

/**
 * Set Password
 */
const SetPassword = () => {
  const intl = useIntl();
  const selectedBanner = banners[0];
  const { id } = useParams();
  const { data, loading } = useQueryData({
    queryName: GET_PUBLIC_USER,
    variables: { token: id },
    skip: !id,
  });
  const user = data?.publicUser || {};
  const { expiredResetPasswordToken, ...rest } = user;

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.SetPassword.Title" })}</title>
      </Helmet>
      <LoginContainer banner={selectedBanner}>
        {loading ? (
          <Spinner />
        ) : expiredResetPasswordToken || !rest?.role ? (
          <span css={invalidLinkStyle}>
            <FormattedMessage id="Global.Link.Expired" values={{ action: "set", entity: "password" }} />
          </span>
        ) : (
          <SetPasswordForm user={rest} resetPasswordToken={id} />
        )}
      </LoginContainer>
    </>
  );
};

const invalidLinkStyle = css`
  line-height: normal;
  font-size: ${fontSize.large};
  color: ${colors.grayAnatomyBase2};
`;

const banners = [
  {
    title: "Built to support careers, not gigs.",
    label: "Faith Adekogbe",
    description: "Frontend Developer",
    cover: `url(${backgroundImage})`,
  },
];

export default SetPassword;
